import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './Spinner.module.scss';
const Spinner = _ref => {
  let {
    style
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Spin, {
    indicator: /*#__PURE__*/React.createElement(LoadingOutlined, {
      style: style,
      spin: true
    })
  }));
};
export default Spinner;
Spinner.propTypes = {
  style: PropTypes.object
};
Spinner.defaultProps = {
  style: {
    fontSize: 36,
    color: '#000'
  }
};